import { routes } from 'config';
import Roles from 'constants/roles';

const getSPRoute = ({ isUserSuperAdmin, domainData }) => {
  const currentUser = domainData.getCurrentUser();
  let spPath = routes.serviceProviders.path;
  if (currentUser && !isUserSuperAdmin) {
    spPath = routes.serviceProviderEdit.path.replace(':id', currentUser.serviceProviderId);
  }
  return spPath;
};

const sideBarData = [
  {
    id: 1,
    label: 'pages.home',
    link: routes.welcome.path,
    icon: 'home',
    iconPosition: 'start',
    height: 40,
    roles: Roles.welcome.access,
  },
  {
    id: 2,
    label: 'pages.subscriptions',
    link: routes.subscriptions.path,
    icon: 'credit_card',
    iconPosition: 'start',
    height: 40,
    roles: Roles.subscriptions.access,
    showSideBarSection: ({ isUserSuperAdmin }) => !isUserSuperAdmin,
  },
  {
    id: 3,
    label: 'pages.sp',
    link: getSPRoute,
    icon: 'supervisor_account',
    iconPosition: 'start',
    height: 40,
    roles: Roles.partner.access,
    showSideBarSection: ({ isUserSuperAdmin }) => isUserSuperAdmin,
  },
  {
    id: 4,
    label: 'pages.spSettings',
    link: getSPRoute,
    icon: 'person',
    iconPosition: 'start',
    height: 40,
    roles: Roles.partner.access,
    showSideBarSection: ({ isUserSuperAdmin }) => !isUserSuperAdmin,
  },
  {
    id: 5,
    label: 'pages.users',
    link: routes.users.path,
    icon: 'groups',
    iconPosition: 'start',
    height: 40,
    roles: Roles.users.access,
  },
  {
    id: 6,
    name: 'portfolioManagement',
    label: 'pages.portfolioManagement',
    height: 40,
    show: ({ isSidebarOpened }) => isSidebarOpened,
    roles: Roles.wines.access,
    isParent: true,
    subMenu: [
      {
        id: 1,
        label: 'pages.winesSpirits',
        link: routes.wines.path,
        icon: 'wine_bar',
        iconPosition: 'start',
        height: 40,
        roles: Roles.wines.access,
      },
      {
        id: 2,
        label: 'pages.wineLists',
        link: routes.wineLists.path,
        icon: 'checklist',
        iconPosition: 'start',
        height: 40,
        roles: Roles.wineLists.access,
      },
    ],
  },
  {
    id: 7,
    name: 'insights',
    label: 'pages.insights',
    height: 40,
    show: ({ isSidebarOpened }) => isSidebarOpened,
    roles: Roles.wineLoversActivities.access,
    isParent: true,
    subMenu: [
      {
        id: 1,
        label: 'pages.dashboard',
        link: routes.dashboard.path,
        icon: 'bar_chart_4_bars',
        iconPosition: 'start',
        height: 40,
        roles: Roles.dashboardMenu.access,
        isFeatured: true,
      },
      {
        id: 1,
        label: 'pages.wineLoversUsers',
        link: routes.wineLovers.path,
        icon: 'diversity_2',
        iconPosition: 'start',
        height: 40,
        roles: Roles.wineLovers.access,
      },
      {
        id: 2,
        label: 'pages.activities',
        link: routes.wineLoversActivities.path,
        icon: 'earthquake',
        iconPosition: 'start',
        height: 40,
        roles: Roles.wineLoversActivities.access,
      },
      {
        id: 3,
        label: 'pages.tasteimonials',
        link: routes.tasteimonials.path,
        icon: 'chat',
        iconPosition: 'start',
        height: 40,
        roles: Roles.tasteimonials.access,
      },
    ],
  },
  {
    id: 8,
    name: 'outreach',
    label: 'pages.outreach',
    height: 40,
    show: ({ isSidebarOpened }) => isSidebarOpened,
    roles: Roles.wineLoversActivities.access,
    isParent: true,
    subMenu: [
      {
        id: 1,
        label: 'pages.campaigns',
        link: routes.campaigns.path,
        icon: 'campaign',
        iconPosition: 'start',
        height: 40,
        roles: Roles.campaigns.access,
        isFeatured: true,
      },
    ],
  },
  {
    id: 9,
    name: 'eu-label',
    label: 'pages.wineLabels',
    height: 40,
    show: ({ isSidebarOpened }) => isSidebarOpened,
    roles: Roles.wines.access,
    isParent: true,
    subMenu: [
      {
        id: 1,
        label: 'pages.labels',
        link: routes.wineLabels.path,
        icon: 'new_label',
        iconPosition: 'start',
        height: 40,
        roles: Roles.wineLabels.access,
      },
    ],
  },
];

export default sideBarData;
